import React from 'react';

import { Wrap, TopContentWrap, BottomContentWrap, SummaryText } from './styles';

const Method = ({
    className,
    gateway,
    topContent: TopContent,
    form: Form,
    uiComponent,
    summaryText,
    handleClick,
    isActive,
    onPaymentMethodCreated,
    onLegacyPaymentMethodCreated,
    orderNumber,
    isNewPaymentOption,
    paymentTermsInfo,
    setPaymentTermsInfo,
}) => {
    return (
        <Wrap className={className} onClick={handleClick}>
            <TopContentWrap>
                <TopContent />
            </TopContentWrap>
            {isNewPaymentOption && (
                <BottomContentWrap isActive={isActive}>
                    <Form
                        onPaymentMethodCreated={onPaymentMethodCreated}
                        onLegacyPaymentMethodCreated={onLegacyPaymentMethodCreated}
                        orderNumber={orderNumber}
                        gateway={gateway}
                        uiComponent={uiComponent}
                        paymentTermsInfo={paymentTermsInfo}
                        setPaymentTermsInfo={setPaymentTermsInfo}
                    />
                </BottomContentWrap>
            )}
            {!isNewPaymentOption && <SummaryText>{summaryText}</SummaryText>}
        </Wrap>
    );
};

export default Method;
